import { TESTIMONIALS, FAQS } from "./portfolio";

export const SITE = "https://www.kaya-the-designer.com";

const PERSON_ID = `${SITE}/#kaya-amah`;
const SERVICE_ID = `${SITE}/#studio`;
const PERSON_REF = { "@type": "Person", "@id": PERSON_ID, name: "Kaya Amah", url: SITE };

export const PERSON_SCHEMA = {
  "@type": "Person",
  "@id": PERSON_ID,
  name: "Kaya Amah",
  url: SITE,
  image: `${SITE}/og-cover.jpg`,
  jobTitle: ["Creative Strategist", "Keynote Designer", "Web Designer"],
  description:
    "Kaya Amah is a creative strategist designing cinematic keynote presentations and brand-led websites for ambitious teams and enterprise clients, including Oracle, Lenovo, Panasonic, and Vital Farms.",
  knowsAbout: [
    "Cinematic, motion-driven keynote presentations",
    "Presentation design",
    "Investor pitch decks",
    "Keynote and conference presentations",
    "Presentation template systems",
    "Web design",
    "Landing page design",
    "Brand-led websites",
    "Motion design",
    "Data visualisation",
    "Creative strategy",
  ],
  address: {
    "@type": "PostalAddress",
    addressRegion: "Florida",
    addressCountry: "US",
  },
  workLocation: {
    "@type": "Place",
    address: { "@type": "PostalAddress", addressRegion: "Florida", addressCountry: "US" },
  },
  brand: ["Oracle", "Apple", "Lenovo", "Panasonic", "Vital Farms"].map((name) => ({
    "@type": "Organization",
    name,
  })),
  worksFor: { "@id": SERVICE_ID },
  sameAs: [SITE, "https://www.linkedin.com/in/kaya-awaza/", "https://www.behance.net/KayaAmah"],
  mainEntityOfPage: { "@type": "WebPage", "@id": SITE },
};

const REVIEWS = TESTIMONIALS.map((t) => ({
  "@type": "Review",
  reviewBody: t.quote,
  author: { "@type": "Person", name: t.author, jobTitle: t.author, worksFor: { "@type": "Organization", name: t.org } },
  reviewRating: { "@type": "Rating", ratingValue: t.rating, bestRating: 5, worstRating: 1 },
  itemReviewed: { "@id": SERVICE_ID },
}));

const SERVICE_SCHEMA = {
  "@type": "ProfessionalService",
  "@id": SERVICE_ID,
  name: "Kaya Amah, Keynote and Website Design",
  url: SITE,
  image: `${SITE}/og-cover.jpg`,
  description: "Cinematic keynote presentations, investor pitch decks, presentation template systems and brand-led websites for ambitious teams and enterprise clients.",
  founder: PERSON_REF,
  areaServed: { "@type": "Place", name: "Worldwide" },
  address: { "@type": "PostalAddress", addressRegion: "Florida", addressCountry: "US" },
  review: REVIEWS,
  aggregateRating: {
    "@type": "AggregateRating",
    ratingValue: (TESTIMONIALS.reduce((s, t) => s + t.rating, 0) / TESTIMONIALS.length).toFixed(1),
    reviewCount: TESTIMONIALS.length,
    bestRating: 5,
    worstRating: 1,
  },
};

const FAQ_SCHEMA = {
  "@type": "FAQPage",
  "@id": `${SITE}/#faq`,
  name: "Working with Kaya, FAQ",
  mainEntity: FAQS.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
};

export const HOME_SCHEMA = {
  "@context": "https://schema.org",
  "@graph": [PERSON_SCHEMA, SERVICE_SCHEMA, FAQ_SCHEMA],
};

export function caseStudySchema(project) {
  const url = `${SITE}/work/${project.slug}`;
  const work = {
    "@type": "CreativeWork",
    "@id": `${url}#work`,
    name: project.title,
    headline: project.title,
    url,
    mainEntityOfPage: { "@type": "WebPage", "@id": url },
    description: project.summary,
    genre: project.category,
    dateCreated: project.year,
    image: project.cover.startsWith("/") ? `${SITE}${project.cover}` : project.cover,
    inLanguage: "en",
    creator: PERSON_REF,
    author: PERSON_REF,
    ...(project.client ? { sourceOrganization: { "@type": "Organization", name: project.client } } : {}),
  };
  const breadcrumb = {
    "@type": "BreadcrumbList",
    itemListElement: [
      { "@type": "ListItem", position: 1, name: "Home", item: SITE },
      { "@type": "ListItem", position: 2, name: "Work", item: `${SITE}/#work` },
      { "@type": "ListItem", position: 3, name: project.title, item: url },
    ],
  };
  return { "@context": "https://schema.org", "@graph": [work, breadcrumb] };
}
